
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
} from 'vue-property-decorator';
import { IRULE } from '@/types/app.d';

interface ErrorTip {
  state: Boolean,
  msg: String,
}

@Component
export default class TInput extends Vue {
  private error: ErrorTip = {
    state: false,
    msg: '',
  }

  @Model('input', { type: String }) value!: string;

  @Prop({
    type: String,
    default: 'text',
  }) type!: string;

  @Prop() rules!: Array<IRULE>;

  @Prop(String) icon?: string;

  @Prop(String) placeholder?: string;

  @Emit('input')
  input(e: any) {
    this.validate(e.target.value);
    return e.target.value;
  }

  /**
   * @author Terry
   * @description 根据正则验证参数值
   * @param { String } value
   * @returns { Boolean }
   */
  validate(value: string = this.value) {
    const errors: Array<IRULE> = this.rules.filter(rule => rule.regex.test(value));
    let flag = true;
    if (errors.length > 0) {
      this.error = { state: true, msg: errors[0].errMsg };
      flag = false;
    } else this.error = { state: false, msg: '' };
    return flag;
  }
}
